import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import {
// 	getList,
// 	updateObj,
// 	delObj,
// 	getCategory,
// 	copyObj,
// 	getObj
// } from '@/api/visual/visual';
import { getList as _getList, updateObj, delObj, getCategory as _getCategory, copyObj, getObj } from '@/api/visual/visual';
import pick from 'lodash.pick';
import { viewHtml } from '@/views/visual/dataScreen/js/utils/html';
import create from '@/views/visual/dataScreen/create';
export default {
  name: "list",
  data: function data() {
    return {
      disableSubmit: false,
      model: {},
      stateDictArr: [{
        label: '未发布',
        value: 0
      }, {
        label: '已发布',
        value: 1
      }],
      form: this.$form.createForm(this),
      wrapperCol: {
        xs: {
          span: 10
        },
        sm: {
          span: 16
        }
      },
      labelCol: {
        xs: {
          span: 5
        },
        sm: {
          span: 5
        }
      },
      validatorRules: {
        category: {
          rules: [{
            required: true,
            message: '请选择 分组!'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入 大屏名称!'
          }]
        },
        password: {
          rules: [{
            required: false,
            message: '请输入 密码!'
          }]
        },
        status: {
          rules: [{
            required: false,
            message: '请选择 发布状态!'
          }]
        }
      },
      dictArr: [],
      showTab: true,
      //组件切换
      typeList: [],
      box: false,
      page: {
        page: 1,
        size: 50,
        total: 0
      },
      activeName: '',
      list: []
    };
  },
  created: function created() {
    this.getCategory();
  },
  components: {
    create: create
  },
  methods: {
    onCancel: function onCancel() {
      this.showTab = true;
    },
    handleSelect: function handleSelect(key) {
      this.activeName = key;
      this.page.page = 1;
      this.getList();
    },
    vaildData: function vaildData(id) {
      var list = [];

      for (var i = 0; i < 20; i++) {
        list.push(i);
      }

      return list.includes(id);
    },
    getCategory: function getCategory() {
      var _this = this;

      _getCategory().then(function (res) {
        var data = res.result;
        _this.typeList = data;
        _this.activeName = (data[0] || {}).value;

        _this.getList();
      });
    },
    handleExport: function handleExport(item) {
      getObj(item.id).then(function (res) {
        var data = res.result;
        var mode = {
          detail: JSON.parse(data.config.detail),
          component: JSON.parse(data.config.component)
        };
        var zip = new window.JSZip();
        zip.file("view.js", "const option =".concat(JSON.stringify(mode, null, 4)));
        zip.file('index.html', viewHtml);
        zip.generateAsync({
          type: "base64"
        }).then(function (content) {
          location.href = "data:application/zip;base64," + content;
        });
      });
    },
    handleCopy: function handleCopy(item) {
      var _this2 = this;

      this.$confirm({
        title: '提示',
        content: '确认复制当前大屏',
        onOk: function onOk() {
          copyObj(item.id).then(function (res) {
            _this2.$message.success('复制成功');

            var id = res.result;

            _this2.getList(); // this.handleEdit({
            // 	id
            // })

          });
        }
      });
    },
    handleDel: function handleDel(item, index) {
      var _this3 = this;

      this.$confirm({
        title: '提示',
        content: '是否确认永久删除?',
        onOk: function onOk() {
          delObj(item.id).then(function () {
            _this3.list.splice(index, 1);

            _this3.$message.success('删除成功');
          });
        }
      });
    },
    handleAdd: function handleAdd() {
      // this.$router.push({
      //   path: '/create', query: {
      //     category: this.activeName
      //   }
      // })
      this.showTab = false;
    },
    handleUpdate: function handleUpdate(item, index) {
      console.log(item);
      this.model = item;
      this.model.category = this.model.category + '';
      this.form.setFieldsValue(pick(this.model, 'title', 'password', 'category', 'status'));
      this.box = true;
    },
    handleEdit: function handleEdit(item) {
      var routeUrl = this.$router.resolve({
        path: '/visual/build/' + item.id
      });
      window.open(routeUrl.href, '_blank');
    },
    handleViews: function handleViews(item) {
      var routeUrl = this.$router.resolve({
        path: '/visualPreview/' + item.id
      });
      window.open(routeUrl.href, '_blank');
    },
    handleSave: function handleSave() {
      var _this4 = this;

      this.form.validateFields(function (err, values) {
        if (!err) {
          var form = Object.assign(_this4.model, values);
          updateObj({
            id: form.id,
            category: form.category,
            password: form.password,
            status: form.status,
            title: form.title
          }).then(function () {
            _this4.$message.success('修改成功');

            _this4.box = false;

            _this4.getList();
          });
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page.page = val;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },
    getList: function getList(category) {
      var _this5 = this;

      this.list = [];

      _getList({
        category: category || this.activeName,
        current: this.page.page,
        size: this.page.size
      }).then(function (res) {
        var data = res.result;
        _this5.page.total = data.total;
        _this5.list = data.records;

        _this5.initData();
      });
    },
    initData: function initData() {
      var _this6 = this;

      this.list.forEach(function (ele, index) {
        _this6.$set(_this6.list[index], '_menu', false);
      });
    }
  }
};